import React from "react";
import { Link } from "react-router-dom";
import flex from "../assets/images/sidom/fotos/FlechaenCirc3.png";
import flex2 from "../assets/images/sidom/fotos/FlechaenCirc1.png";

export default function ButtonOrang({
  text,
  link = "#",
  background = "bg-sidom-orange",
  textColor = "text-white",
  borderColor = "border-transparent",
  showLineEffect = true,
  width,
}) {
  return (
    <div className="relative">
      <Link
        to={`${link}`}
        className={`relative ${width}  inline-flex h-12 transition active:scale-95 overflow-hidden rounded-full p-[1px] focus:outline-none`}
      >
        {showLineEffect && (
          <div className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#ff7a00_0%,#fff_100%)]"></div>
        )}
        <div
          className={`relative inline-flex  leading-snug h-full w-full items-center justify-center rounded-full px-5 text-nowrap text-base gap-3 ${borderColor} ${background} ${textColor}`}
        >
          {" "}
          <h3 className="font-extrabold tracking-wide ">{text}</h3>
          <img src={flex} alt="Logo " className="hidden dark:block w-5" />
          <img src={flex2} alt="Logo " className="block dark:hidden w-5" />
        </div>
      </Link>
    </div>
  );
}
